<template>
    <v-bottom-navigation
        background-color="sidebar" color="primary" height="56" app fixed :value="navActiveRef"
        :style="{ '--btn-min-width': btnMinWidth }"
        :class="['nav-container', 'redesign-bottomnav', {'disable-footer': dialogStack.length > 0}]"
    >
        <v-btn
            v-for="item in items" :key="item.title"
            :id="item.ref"
            :ref="item.ref"
            :value="item.ref"
            :to="item.link || null"
            exact
        >
            <div v-if="item.count && item.count > 0" class="badge">
                {{ item.count }}
            </div>
            <span>{{ item.title }}</span>
            <v-icon size="22">{{ item.icon }}</v-icon>
        </v-btn>
    </v-bottom-navigation>

</template>

<script>

import {links} from "@/mixins/baseGlobalMixin";

export default {
    components: {},
    mixins: [links],
    computed: {
        btnMinWidth(vm = this) {
            return `${100 / (vm.items.length || 1)}%`
        }
    }
}
</script>

<style scoped>

.badge {
    opacity: 1 !important;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    color: #fff;
    top: 6px !important;
    right: -12px !important;
    padding: 2px 6px;
    font-size: 10px;
    min-width: 14px;
    min-height: 14px;
    border-radius: 14px;
    background-color: var(--v-error-base);
}

.nav-container {
    z-index: 7;
    box-shadow: none;
    height: calc(56px + var(--safe-area-inset-bottom, 0px)) !important;
    padding-bottom: var(--safe-area-inset-bottom, 0px) !important;
}

.redesign-bottomnav {
    border-top: 1px solid #1F2430 !important;
}

.redesign-bottomnav ::v-deep .v-btn {
    background-color: transparent !important;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0;
}

.redesign-bottomnav ::v-deep .v-btn:not(.v-btn--active) {
    color: #5A6677 !important;
}

.redesign-bottomnav ::v-deep .v-btn .v-icon {
    margin-bottom: 3px;
}

.redesign-bottomnav ::v-deep .v-btn {
    height: 56px !important;
    align-self: flex-start;
}

.redesign-bottomnav ::v-deep .v-btn--active::after {
    content: '';
    position: absolute;
    bottom: 4px;
    left: 50%;
    transform: translateX(-50%);
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: var(--v-primary-base);
}

::v-deep .v-btn.v-btn--router.v-size--default {
    min-width: var(--btn-min-width, 20%);
}

::v-deep .v-btn:not(.v-btn--text):not(.v-btn--outlined):hover:before {
    opacity: 0;
}

.disable-footer {
    pointer-events: none;
}

</style>
